import React from 'react'
export default ( { children, className, handleClick, id, target, url } ) => (
  <a
    className={ className }
    id={ id }
    href={ url }
    target={ target }
    onClick={ handleClick }
    >
    { children }
  </a>
)
